<template>
  <div :class="classObj" class="app-wrapper">
    <template
      v-if="
      $route.path === '/deviceMan/deviceFileMan/formProcessDesign' ||
        $route.path === '/administrationOA/formProcessDesign' ||
          $route.path === '/administrationOA/mbInitiateProcess' ||
          $route.fullPath.indexOf('type=app') >= 0||
          $route.fullPath.indexOf('/examMan/examOnline/web/exam/start') >= 0||
          $route.fullPath.indexOf('/jytQueueScreen') >= 0
      "
    >
      <!-- <navbar /> -->
      <!-- <tags-view /> -->
      <app-main style="height: calc(100vh);padding:0; overflow: auto;" />
    </template>

    <template v-else>
      <!-- 左侧导航 -->
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />

      <sidebar class="sidebar-container" />
      <!-- 右侧 -->
      <div class="main-container">
        <navbar />
        <tags-view />
        <app-main />
        <div class="fs12 app-bottom" style="color: #909399">
          CopyRight &copy; 哈尔滨市维舟物业管理有限公司
          <a
            style="color: #909399"
            title="待备案成功"
            href=""
            >待备案成功</a
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("closeSideBar", { withoutAnimation: false });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

// 底部 备案
.app-bottom {
  position: fixed;
  z-index: 9;
  bottom: 0px;
  width: 100%;
  background: #fff;
  line-height: 34px;
  height: 34px;
  box-sizing: border-box;
  padding: 0 10px;
}
</style>
